import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api/doctors`;

const authService = {
  // Login
  login: async (credentials) => {
    const response = await axios.post(`${API_URL}/login`, credentials);
    return response.data;
  },

  // Register
  register: async (userData) => {
    const response = await axios.post(`${API_URL}/register`, userData);
    return response.data;
  },

  // Forgot Password
  forgotPassword: async (email) => {
    const response = await axios.post(`${API_URL}/forgot-password`, {
      email,
    });
    return response.data;
  },

  // Reset Password
  resetPassword: async (token, newPassword) => {
    const response = await axios.post(`${API_URL}/reset-password`, {
      token,
      newPassword,
    });
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem("doctorToken");
    localStorage.removeItem("doctorId");
  },

  // Get token
  getToken: () => {
    return localStorage.getItem("doctorToken");
  },
};

export default authService;
